export default __webpack_public_path__ + "static/media/shop-right.976485fa.png";